import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as groupActions from 'redux/modules/groups';
import { initializeWithKey } from 'redux-form';
import { GroupForm } from 'components';

import { ReduxAsyncConnect, asyncConnect, reducer as reduxAsyncConnect } from 'redux-connect'

import { Col, OverlayTrigger, Button, Row, DropdownButton, MenuItem, Tooltip, Panel } from 'react-bootstrap';

var _ = require('underscore');
import { DeleteButton } from 'components';

import { LinkContainer } from 'react-router-bootstrap';

import { isLoaded as areGroupsLoaded, load as loadGroups } from 'redux/modules/groups';
import { isLoaded as areUsersLoaded, load as loadUsers } from 'redux/modules/users';
import { isLoaded as areFichesLoaded, load as loadFiches } from 'redux/modules/fiches';

import { GSMList } from 'components';
import { UserList } from 'components';


//import TreeView from 'react-treeview';

require('react-treeview/react-treeview.css');

import * as UserActions from 'redux/modules/users';

import { ErrorAlert } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
	promise: ({ store: { dispatch, getState }, params }) => {
		const promises = [];
		promises.push(dispatch(loadGroups(params)));
		promises.push(dispatch(loadUsers(params)));
		promises.push(dispatch(loadFiches(0, params)));
		return Promise.all(promises);
	}
}])
@connect(
	state => ({
		groups: state.groups.data,
		editing: state.groups.editing,
		error: state.groups.error,
		loading: state.groups.loading,
		users: state.users.data,
		fiches: state.fiches.data,
		user: state.auth.user
	}),
	{ ...groupActions, initializeWithKey })

export default class Groups extends Component {

	constructor(props) {

		super(props);

		var openedProducts = {}

		_.each(props.groups, (g) => {
			openedProducts[g.id] = false
		})

		this.state = {
			displayUserList: false,
			displayGSMList: false,
			currentGroup: undefined,
			users: [],
			fiches: [],
			active: null,
			openedProducts
		}

		this.associateUser = this.associateUser.bind(this);
		this.associateGSM = this.associateGSM.bind(this);
		this.calculateFichesUsers = this.calculateFichesUsers.bind(this);
		this.onClickNode = this.onClickNode.bind(this);
		this.renderNode = this.renderNode.bind(this);
		this.updateTree = this.updateTree.bind(this);
		this.togglePanel = this.togglePanel.bind(this);
	}

	togglePanel(gid) {
		var openedProducts = this.state.openedProducts;
		openedProducts[gid] = !openedProducts[gid]
		this.setState({ openedProducts })
	}

	onClickNode(node) {
		this.setState({
			active: node
		});
	}

	handleChange(tree) {
		this.setState({
			tree: tree
		});
	}

	renderNode(node) {
		return (
			<span className={cx('node', {
				'is-active': node === this.state.active
			})} onClick={this.onClickNode.bind(null, node)}>
				{node.module}
			</span>
		);
	}

	updateTree() {
		var tree = this.state.tree;
		tree.children.push({ module: 'test' });
		this.setState({
			tree: tree
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.groups !== this.props.groups || prevProps.users !== this.props.users) {
			try {
				var groups = this.props.groups;
				var group = _.where(groups, { id: this.state.currentGroup })[0];
				this.setState(this.calculateFichesUsers(group, this.props))
			} catch (e) {

			}
		}
	}

	calculateFichesUsers(group, props) {

		var users = [];
		_.each(props.users, (user) => {
			if (group.users.indexOf(user.id + ':' + user.login) < 0) {
				users.push(user)
			}
		})

		var fiches = [];

		var list = group.gsms.map((gsm) => {

			if (gsm.products) {
				return gsm.phone;
			}

		})

		var fichesWithProducts = [];

		_.each(props.fiches, (fiche) => {
			if (list.indexOf(fiche.gsm) < 0) {
				fiches.push(fiche)
			}
			if (fiche.products.length > 0) {
				fichesWithProducts.push(fiche)
			}
		})

		return { fiches, users }
	}


	associateUser(user) {
		this.props.userToGroup(user, this.state.currentGroup, this.props.params)
	}

	associateGSM(fiche) {
		this.props.siteToGroup(fiche, this.state.currentGroup, this.props.params)
	}


	render() {

		var self = this;

		const {
			loading, load, save,
			users, fiches, currentGroup, params, groups, editing, error, user, t
		} = this.props;

		
		const handleLoad = (params) => {
			const { loadGroups } = this.props; // eslint-disable-line no-shadow
			return () => loadGroups(params);
		};

		const handleEdit = (group) => {
			const { editStart } = this.props; // eslint-disable-line no-shadow
			return () => this.setState({ currentGroup: group.id }, () => { editStart(String(group.id)) });
		};

		const handleEditStop = (groupId) => {
			const { editStop } = this.props; // eslint-disable-line no-shadow
			this.setState({ displayUserList: false, displayGSMList: false, currentGroup: null }, () => { editStop(String(groupId)) });
		};

		const handleDelete = (groupId) => {
			const { deleteGroup } = this.props; // eslint-disable-line no-shadow
			return () => deleteGroup(parseInt(groupId), this.props.params);
		};

		var fichesWithProducts = [];
		var nfiches = [];
		_.each(this.state.fiches, (f) => {
			if (f.gsm) {
				nfiches.push(f);
			}

			if (f.products.length > 0) {
				fichesWithProducts.push(f);
			}

		})

		let refreshClassName = 'fa fa-refresh';
		if (loading) {
			refreshClassName += ' fa-spin';
		}
		const styles = require('./Groups.scss');

		var cid = this.props.params.id
		var addUrl = ''

		if (user.role == 'admin') {
			addUrl = '/admin/groups/' + cid + '/create';
		} else if (user.role.indexOf('client') > -1 || user.role == 'demo') {
			addUrl = '/client/addgroup';
		} else {
			addUrl = '/user/group/addGroup';
		}


		var table_rows = [];

		_.each(this.props.groups, (group) => {
			var trStyle = group.id == this.state.currentGroup ? { background: '#e0f7ff' } : {}

			var users = group.users.map((user) => {
				user = user.split(':');

				if (editing[group.id]) {

					const tooltip = (
						<Tooltip id="tooltip">
							<b>{t('groups.remove_user_from_group')}</b>
						</Tooltip>
					);

					return (

						<div style={{ position: 'relative' }}>

							{user[1]}{/*parseInt(user[2]) == 0 ? '-usr' : '-sup'*/}&nbsp;

							<OverlayTrigger placement="top" overlay={tooltip}>

								
								<DeleteButton ctext={t('main.confirm')} circle={true} isPromise={true} size="xs" style={{height:'30px', width:'50px'}}								
									callback={() => {
										return new Promise((resolve, reject) => {
											if (!this.props.loading) {
												this.setState({ currentGroup: group.id, displayUserList: true, displayGSMList: false }, () => {
													self.props.removeUserFromGroup(group.id, user[0], self.props.params).then(() => {
														self.props.dispatch(UserActions.clear());
														resolve(1);
													});
												});
											} else {
												reject(0)
											}
										})
									}} 
								/>
							</OverlayTrigger>
						</div>
					);
 
				} else {
					return <div>{user[1]}{/*parseInt(user[2]) == 0 ? '-usr' : '-sup'*/}</div>
				}
			})

			const dataSource = [];

			var gsms = _.each(group.gsms, (gsm) => {
				var phone = gsm.phone;
				var s_id = gsm.s_id;

				var productArray = []

				if (gsm.products) {

					_.each(gsm.products, (product) => {
						//product = product.split(";")
						productArray.push({
							id: product.id,
							adresse: product.localisation_adresse,
							ville: product.localisation_ville,
							identification_NUM_ASC: product.identification_NUM_ASC,
							identification_ID: product.identification_ID
						});
					});

					dataSource.push({
						gsm: phone,
						s_id: s_id,
						collapsed: false,
						products: productArray
					});

				}

			});


			var generateGSMTree = (dataSource) =>
				dataSource.map((node, i) => {
					const gsm = node.gsm;

					//var label = <span className="node" title={node.products.map((p)=>p.identification_NUM_ASC).join(',')}>{' Ensemble fiches '+(i+1)}</span>;

					//var label = <span className="node" title={node.products.map((p)=>p.identification_NUM_ASC).join(',')}>{node.gsm}</span>;

					var label = ''
					if (editing[group.id]) {
						const tooltip = (
							<Tooltip id="tooltip"><b>{t('groups.remove_products_from_group')}</b></Tooltip>
						);


						var label = (
							<div className="node" style={{ textAlign: 'right' }} title={node.products.map((p) => p.identification_NUM_ASC).join(',')}>

								<OverlayTrigger placement="top" overlay={tooltip}>
									<DeleteButton ctext={t('main.confirm')} circle={true} isPromise={true} size="xs" callback={() => {
										return new Promise((resolve, reject) => {
											if (!this.props.loading) {
												self.props.removeSiteFromGroup(group.id, node.s_id, self.props.params).then(() => {
													self.props.dispatch(UserActions.clear());
													this.setState({ currentGroup: group.id, displayUserList: false, displayGSMList: true }, () => {
														resolve(1);
													});
												});
											} else {
												reject(0)
											}
										})
									}} />
								</OverlayTrigger>

							</div>);

						/*
						label = (
							<div className="node" style={{display:'inline-block'}} title={node.products.map((p)=>p.identification_NUM_ASC).join(',')}>
								{' Ensemble fiches '+(i+1)}&nbsp; 
								<OverlayTrigger placement="top" overlay={tooltip}>
									<DeleteButton ctext="Confirmer" circle={true} isPromise={true} size="xs" callback={()=>{
												return new Promise ( (resolve, reject)=>{
													if( ! this.props.loading ) {
													self.props.removeSiteFromGroup(group.id, node.s_id, self.props.params).then(()=>{
														self.props.dispatch(UserActions.clear());
														this.setState({currentGroup:group.id, displayUserList:false, displayGSMList:true}, ()=>{
															resolve(1);
														});
													});
												} else {
														reject(0)
													}
												})
											}}/>
							</OverlayTrigger>
							
						</div>);*/
					}

					const generateProducts = (products) => {
						return products.map((product, i) => {
							const label2 =
								<span>
									{t('main.num_asc')} {product.identification_NUM_ASC || '-'}
								</span>

							var tooltipP = (
								<Tooltip id="tooltip">
									<div className="info">{product.adresse}</div>
									<div className="info">{product.ville}</div>
									<div className="info">{t('main.module')} : {product.module}</div>
								</Tooltip>
							);


							return (
								<div>
									{label2} &nbsp;
                  					<OverlayTrigger placement="top" overlay={tooltipP}>
										<i style={{ cursor: 'pointer' }}
											className="fa fa-info-circle"
											aria-hidden="true"
										>
										</i>
									</OverlayTrigger>
								</div>
							);
						})
					};


					var products = [];

					if (node.products.length > 0) {

						//products = <Panel collapsible header={label} defaultExpanded={true}>{generateProducts(node.products)}</Panel>
						products = <Panel collapsible header={label} defaultExpanded={true}>{generateProducts(node.products)}</Panel>


						return (
							<div>
								{products}
							</div>
						)

					} else {
						return <span>{label}</span>
					}
	
				})

			var firstGSM = generateGSMTree(dataSource.slice(0, 1))
			var gsmTree = generateGSMTree(dataSource.slice(1))

			var tooltipUser = (
				<Tooltip id="tooltip"><b>{t('groups.add_user_to_group')}</b></Tooltip>
			);

			var tooltipSite = (
				<Tooltip id="tooltip"><b>{t('groups.add_products_to_group')}</b></Tooltip>
			);

			var addUser = this.state.users.length > 0 ?
				<OverlayTrigger placement="top" overlay={tooltipUser}>
					<i style={{ cursor: 'pointer' }}
						className="fa fa-user-plus fa-lg"
						aria-hidden="true"
						onClick={() => {
							var userList = self.calculateFichesUsers(group, self.props).users;
							self.setState({ currentGroup: group.id, displayUserList: true, displayGSMList: false, users: userList })
						}}>
					</i>
				</OverlayTrigger> : "";



			var gsmsNb = group.gsms.length;
			var usersNb = group.users.length;


			var addSite = (

				<div>
					<OverlayTrigger placement="top" overlay={tooltipSite}>

						<Button bsStyle="primary" onClick={() => {
							var gsmList = self.calculateFichesUsers(group, self.props).fiches;
							self.setState({
								currentGroup: group.id,
								displayGSMList: true,
								displayUserList: false,
								fiches: gsmList
							});
						}}>
							{t('groups.add_products')}

						</Button>

					</OverlayTrigger>
					<br />
				</div>
			)


			if (this.props.fiches && this.props.fiches.length == 0) {
				addSite = t('groups.create_product_associate')
			}

			if (this.props.users.length == 0) {
				addUser = t('groups.create_user_associate')
			}

			var tooltipEdit = (
				<Tooltip id="tooltip"><b>{t('groups.edit_group')}</b></Tooltip>
			);

			var tooltipDelete = (
				<Tooltip id="tooltip"><b>{t('groups.delete_group')}</b></Tooltip>
			);



			if (editing[group.id]) {

				table_rows.push(
					<GroupForm urlParams={this.props.params}
						formKey={String(group.id)}
						groupId={group.id}
						key={String(group.id)}
						initialValues={group}
						users={users}
						gsms={firstGSM.concat(gsmTree)}
						trStyle={trStyle}
						handleEditStop={handleEditStop}
						addUser={addUser}
						addSite={addSite}
					/>
				);
			} else {
				table_rows.push(
					<tr key={group.id} style={trStyle}>
						<td>{group.name}</td>
						<td style={{ position: 'relative' }}><div style={{ maxHeight: '200px', overflow: 'auto' }}>{users}</div></td>
						<td style={{ position: 'relative' }} >
							{firstGSM}

							{gsmTree.length > 0 &&
								<div>
									<Button bsStyle="info" onClick={() => this.togglePanel(group.id)} style={{ cursor: 'pointer' }}>
										{this.state.openedProducts[group.id] ? t('main.hide') : t('main.display_all')}
									</Button>
									<br />

								</div>

							}

							<div style={{ maxHeight: '200px', overflow: 'auto', display: this.state.openedProducts[group.id] ? 'block' : 'none' }}>
								{gsmTree}
							</div>
						</td>
						<td className="" style={{ position: 'relative' }}>
							<OverlayTrigger placement="top" overlay={tooltipEdit}>
								<button className="btn btn-primary btn-sm" onClick={handleEdit(group)}>
									<i className="fa fa-pencil" />
								</button>
							</OverlayTrigger>
							&nbsp;
	          				<OverlayTrigger placement="top" overlay={tooltipDelete}>

								<DeleteButton ctext="Confirmer" size="sm" callback={handleDelete(group.id)} />

							</OverlayTrigger>



						</td>
					</tr>
				);
			}
		})

		const { displayGSMList, displayUserList } = this.state;


		return (
			<div>
				<div className={styles.groups + ' container'}>
					<div>
						<h1>
							<i className="fa fa-users fa-md" aria-hidden="true"></i> {t('main.groups')}&nbsp;
		        				<button className={'btn btn-success'} onClick={() => {
									self.props.dispatch(loadGroups(params));
								}}>

									<i className={refreshClassName} />
								</button>&nbsp;

	          				<LinkContainer to={addUrl}>
								<button className={'btn btn-primary'}>
									<i className='fa fa-users' /> {' '} {t('main.create_a_group')}
		          				</button>
							</LinkContainer>
						</h1>
					</div>


					<Helmet title={t('main.groups')} />

					{error &&
						<ErrorAlert buttonText={t('dashboardView.reload_page')} errorMessage={error} callback={() => {
							self.props.dispatch(loadGroups(params));

						}} />
					}

					<Row>
						<Col md={6} xs={6}>
							<p>{t('groups.create_group_desc')}</p>
						</Col>
					</Row>

					<Row>
						<Col md={displayGSMList || displayUserList ? 8 : 12} xs={12}>
							<div className="table-responsive">

								{groups && groups.length > 0 &&
									<table className="table table-striped">
										<thead>
											<tr>
												<th className="col-md-2">{t('main.name')}</th>
												<th className="col-md-3">{t('main.users')}</th>
												<th className="col-md-3">{t('main.sheets')}</th>
												<th className="col-md-2">{t('main.actions')}</th>
											</tr>
										</thead>
										<tbody>
											{table_rows}
										</tbody>
									</table>}
							</div>
						</Col>

						<Col md={4} xs={12}>
							<div style={{ display: this.state.displayUserList ? 'block' : 'none', float: 'left', width: '450px', maxWidth: '100%' }}>
								<UserList loading={loading} params={params} associateUser={this.associateUser} users={this.state.users} currentGroup={currentGroup} />
							</div>
							<div style={{ display: this.state.displayGSMList ? 'block' : 'none', float: 'left', width: '450px', maxWidth: '100%' }}>
								<GSMList
									loading={loading}
									params={params}
									associateGSM={this.associateGSM}
									fiches={fichesWithProducts}
									currentGroup={currentGroup}
									group={_.where(groups, { id: this.state.currentGroup })[0]}
								/>
							</div>

						</Col>

					</Row>

				</div>

			</div>


		);
	}
}

